import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { IEfectoFullscreen } from 'modelos/src';

interface Particula {
  left: number;
  delay: number;
  duration: number;
  size: number;
  driftClass: 'd0' | 'dl' | 'dr';
}

@Component({
  selector: 'app-tema-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tema-overlay.component.html',
  styleUrl: './tema-overlay.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class TemaOverlayComponent implements OnChanges {
  @Input() efecto?: IEfectoFullscreen | null;
  /** Si true, el overlay se contiene dentro de su host (preview en form). Si false, fixed fullscreen. */
  @Input() contenido = false;

  public particulas: Particula[] = [];

  ngOnChanges(_: SimpleChanges): void {
    this.regenerar();
  }

  private regenerar() {
    if (!this.efecto) {
      this.particulas = [];
      return;
    }
    const cantidad = Math.max(1, Math.min(128, this.efecto.cantidad ?? 32));
    const velMin = this.efecto.velocidad?.min ?? 10;
    const velMax = Math.max(velMin + 0.1, this.efecto.velocidad?.max ?? 20);
    const tamMin = this.efecto.tamano?.min ?? 12;
    const tamMax = Math.max(tamMin + 0.1, this.efecto.tamano?.max ?? 20);
    const drift = this.efecto.drift ?? 30;
    const out: Particula[] = [];
    for (let i = 0; i < cantidad; i++) {
      const r = Math.random();
      out.push({
        left: Math.random() * 100,
        delay: Math.random() * (velMax * 0.75),
        duration: velMin + Math.random() * (velMax - velMin),
        size: tamMin + Math.random() * (tamMax - tamMin),
        driftClass:
          drift === 0 ? 'd0' : r < 0.33 ? 'd0' : r < 0.66 ? 'dl' : 'dr',
      });
    }
    this.particulas = out;
  }
}
